import { type GoogleProtobufTimestamp, ReportingGranularity } from "../../gql-generated/types";
import { makeUTCStartEndTimestamp } from "../converters";
import { GranularityInDays, LensGranularity } from "../models";

import { useTimeRange } from "./useTimeRange";

interface UseReportingGranularityParams {
    defaultRange?: LensGranularity;
}

export const useReportingGranularity = (
    params?: UseReportingGranularityParams,
): {
    startTime: GoogleProtobufTimestamp | null;
    endTime: GoogleProtobufTimestamp | null;
    selectedGranularity: ReportingGranularity;
} => {
    const { selectedTimeRange } = useTimeRange({ defaultRange: params?.defaultRange });

    const selectedGranularity =
        selectedTimeRange === LensGranularity.Lifetime ? ReportingGranularity.Lifetime : ReportingGranularity.Total;

    const { startTime, endTime } = makeUTCStartEndTimestamp(GranularityInDays[selectedTimeRange]);

    return {
        startTime,
        endTime,
        selectedGranularity,
    };
};
